import service, {clickEventId} from "@irati-tracking/tracker"

interface BuyPointsEventData {
  type?: string
  perkbox_product?: string
  source?: string
}
class Tracking {
  clickChristmasBanner = (source: string, data: {type: "buy_points" | "learn_more"}) => {
    service.trackRewardEvent(clickEventId, {source, ...data})
  }

  clickSubscriptionBanner = (source: string, data: {type: string}) => {
    service.trackRewardEvent(clickEventId, {source, ...data})
  }

  clickSubscriptionConfirm = (
    amount: number | string,
    duration: "quarterly" | "monthly" | "yearly",
    source: "rp_subscription_modal" | "rp_subscription_checkoutbanner",
    referrer?: string
  ) => {
    service.trackRewardEvent(clickEventId, {source, type: `joinWaitlist_${duration}_${amount}`, referrer})
  }

  clickRewardPointsWallet = (role: string) => {
    const data = {role}
    service.trackWalletEvent("wallet_navigate_reward_wallet", data)
  }

  browseRewardCatalogue = () => {
    service.trackWalletEvent("wallet_click_reward_catalogue", {})
  }

  walletSelectRegion = (regions: string[], role: string) => {
    const data = {regions, role}
    service.trackWalletEvent("wallet_click_select_region", data)
  }

  buyPoints = (eventData: BuyPointsEventData) => {
    service.trackWalletEvent("wallet_click_buy_points", eventData)
  }

  giveRewardPoints = (source: string) => {
    service.trackWalletEvent("wallet_click_give_points", {source})
  }

  createBudgets = () => {
    service.trackWalletEvent("wallet_budget_click_create_budget")
  }

  viewBudgets = (source: string) => {
    service.trackWalletEvent("wallet_budget_click_view_budget", {source})
  }

  cancelBudgetChange = () => {
    service.trackWalletEvent("wallet_budget_click_budget_cancel_change")
  }

  confirmBudgetChange = (delta: Record<string, string | number | boolean>) => {
    service.trackWalletEvent("wallet_budget_click_budget_confirm_change", delta)
  }

  learnMore = () => {
    service.trackWalletEvent("wallet_budget_click_learn_more")
  }

  selectAssignBudget = (role: string) => {
    const data = {role}
    service.trackWalletEvent("wallet_click_assign_budget", data)
  }

  assignBudgetSuccess = () => {
    service.trackWalletEvent("reward_wallet_assign_budget_success")
  }

  assignBudgetError = (error: string) => {
    const data = {error}
    service.trackWalletEvent("reward_wallet_assign_budget_error", data)
  }

  selectRewardEmployees = (role: string) => {
    const data = {role}
    service.trackWalletEvent("wallet_click_reward_employees", data)
  }

  rewardEmployeesSuccess = (template?: string) => {
    service.trackWalletEvent("reward_wallet_reward_employees_success", {template: template || "default"})
  }

  rewardEmployeesError = (error: string) => {
    const data = {error}
    service.trackWalletEvent("reward_wallet_reward_employees_error", data)
  }

  payByCard = (role: string) => {
    const data = {role}
    service.trackWalletEvent("wallet_click_buy_points_card", data)
  }

  payByCardSuccess = () => {
    service.trackWalletEvent("wallet_click_buy_points_card_success")
  }

  payByCardError = (error: string) => {
    const data = {error}
    service.trackWalletEvent("wallet_click_buy_points_card_error", data)
  }

  bankTransfer = (role: string) => {
    const data = {role}
    service.trackWalletEvent("wallet_click_buy_points_bank", data)
  }

  bankTransferSuccess = (role: string) => {
    service.trackWalletEvent("wallet_click_buy_points_bank_success", {role})
  }

  employeesManualEnter = () => {
    service.trackWalletEvent("wallet_click_add_employees_manually")
  }

  employeesCSVUpload = () => {
    service.trackWalletEvent("wallet_click_add_employees_csv")
  }

  uploadCsv = (prop: string) => {
    const data = {prop}
    service.trackWalletEvent("wallet_click_upload_csv", data)
  }

  continueToCheckoutScreen = (source: string, data: {role: string}) => {
    service.trackRewardEvent(clickEventId, {source, ...data})
  }
}

export default new Tracking()
